<template>
  <div>
    <van-field
      v-model="showText"
      clearable
      readonly
      :columns="selectList"
      :label="label"
      :placeholder="placeholder"
      required
      @click="onClickField"
    />
    <van-popup v-model="showPopupSelect" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :columns="selectList"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import { Field, Popup, Picker } from 'vant'
export default {
  components: {
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Picker.name]: Picker
  },
  props: {
    // eslint-disable-next-line
    label: String,
    // eslint-disable-next-line
    placeholder: String,
    // eslint-disable-next-line
    value: String,
    list: undefined
  },
  data() {
    return {
      isDisable: false,
      showPopupSelect: false,
      selectObject: undefined,
      showText: '',
      fieldLable: '',
      fieldPlaceholder: '',
      selectList: [],
      selectKey: undefined
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.selectObject = undefined
        this.showText = ''
        console.log('new this.selectKey', this.selectKey)
        console.log('new this.selectList', this.selectList)
        this.selectKey = newValue
        this.selectList.forEach(item => {
          if (item.value === this.selectKey) {
            this.selectObject = item
            this.showText = this.selectObject.text
            this.selectKey = undefined
          }
        })
        // this.selectObject = newValue
        // this.showText = this.selectObject.text
      }
    },
    placeholder(newValue) {
      this.fieldPlaceholder = newValue
    },
    label(newValue) {
      this.fieldLable = newValue
    },
    isdisabled(newValue) {
      this.isDisable = newValue
      console.log('disabled发生变化', newValue)
    },
    list(newValue) {
      this.selectObject = undefined
      this.showText = ''
      console.log('List发生变化', newValue)

      this.selectList = newValue
      if (this.selectList.length === 1) {
        this.selectObject = this.selectList[0]
        this.showText = this.selectObject.text
        this.$emit('change', this.selectObject)
      }
      console.log('1this.selectKey', this.selectKey)
      if (this.selectKey) {
        this.selectList.forEach(item => {
          console.log('item', item)
          console.log('this.selectKey', this.selectKey)
          if (item.value === this.selectKey) {
            this.selectObject = item
            this.showText = this.selectObject.text
            this.selectKey = undefined
          }
        })
      }
    }
  },
  created() {
  },
  methods: {
    onConfirm(value, index) {
      this.showPopupSelect = false
      this.selectObject = value
      this.showText = this.selectObject.text
      this.$emit('change', this.selectObject)
    },
    onCancel() {
      this.showPopupSelect = false
    //   this.selectObject = undefined
    //   this.showText = ''
    //   this.$emit('input', this.selectObject)
    //   this.$emit('change', this.selectObject)
    },
    onClickField() {
      if (this.isDisable) {
        return
      }
      console.log('onClickField', this.selectList)
      this.$emit('open', this.selectList.length)
      if (!this.selectList || this.selectList.length <= 0) {
        return
      }
      this.showPopupSelect = true
    }

  }
}
</script>

